const base = "shengchan";

const _filePreviewUrl = {
    kaifa:"https://y21091w776.goho.co",
    shengchan:"https://jgwg.daxingzw.com/preview",
}

export default {
    filePreviewUrl:_filePreviewUrl[base]
}
